/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Defines a contract change log. Contract log contains information about what contract has been assigned to the Tenant at the specified point in time.
 */
export interface ContractLogDTO { 
    /**
     * Month, since when the change takes effect.
     */
    from: string;
    /**
     * Month when the contract changed or ended. Note: This month is excluded (the value represents the first second of the month).
     */
    to?: string;
    /**
     * System generated UID for the contract.
     */
    contractId: string;
}

export class ClsContractLogDTO { 
    /**
     * Month, since when the change takes effect.
     */
    from: string = undefined;
    /**
     * Month when the contract changed or ended. Note: This month is excluded (the value represents the first second of the month).
     */
    to?: string = undefined;
    /**
     * System generated UID for the contract.
     */
    contractId: string = undefined;
}

